import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

export default class ReportExpired extends Component {
  render() {
    return (
      <div className="card p-0">
        {this.props.expiredReportEntries.length ?
          <table className="table table-striped table-bordered datatable mb-0">
            <thead>
              <tr>
                <th>ID</th>
                <th>Item</th>
                <th className="hidden-md-down">Item Number</th>
                <th className="hidden-md-down">Location</th>
                <th className="hidden-md-down">Packing Date</th>
                <th className="hidden-md-down">Receive Date</th>
                <th className="hidden-xs-down">Days on Inventory</th>
              </tr>
            </thead>
            <tbody>
              {this.props.expiredReportEntries.map((i,idx) => {
                return (
                  <tr key={idx}>
                    <td>
                      <NavLink to={`/inventory/${i.id}/`}>
                        {i.id}
                      </NavLink>
                    </td>
                    <td>{i.item}</td>
                    <td className="hidden-md-down">{i.item_number}</td>
                    <td className="hidden-md-down">{i.location || '-'}</td>
                    <td className="hidden-md-down">{i.packing_date}</td>
                    <td className="hidden-md-down">{i.receive_date}</td>
                    <td className="hidden-xs-down">{i.days_on_inventory || '-'}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        :
          <div className="shipment-no-items mb-0">
            No results for given filters
          </div>
        }
      </div>
    )
  }
}
